import { AppBar, Dialog, DialogContent, Toolbar, Typography, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { fmtDE, parseD } from "../utils/statusUtils";

const PendingElementDialog = ({ element, open, onClose, onCompletedClick }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            TransitionProps={{ unmountOnExit: true }}
            PaperProps={{ sx: { borderRadius: 2 } }}
        >
            <AppBar
                className="appBar"
                position="relative"
                sx={{ bgcolor: "background.paper", color: "text.primary", }}
            >
                <Toolbar className="dialog-toolbar" sx={{ display: "flex", justifyContent: "space-between", }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, width: '100%' }}>
                        Pending Inspection Details
                    </Typography>
                    <IconButton
                        edge="end"
                        color="inherit"
                        aria-label="close"
                        onClick={onClose}
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <DialogContent dividers sx={{ px: 3, pt: 3 }}>
                <Box sx={{ display: "flex", flexDirection: "row", width: "100%", justifyContent: "space-between" }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                            {element?.elementName}
                        </Typography>
                        <Typography variant="body1">
                            Due on <span style={{ fontWeight: 'bold' }}>{ element?.reinspectionRequired.trim() === '' ? fmtDE(element?.nextInspectionDate) : element?.reinspectionRequired}</span>
                        </Typography>
                    </Box>
                    <Typography onClick={onCompletedClick} variant="body1" sx={{ ml: 4, alignSelf: 'center', textDecoration: 'underline', cursor: 'pointer', color: '#97b444', fontWeight: 'bold' }}>
                        Mark as Completed
                    </Typography>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default PendingElementDialog;